module.exports = __webpack_public_path__ + "2c89cec0f9b0b7c3b40dcbd9959e126a.svg";